import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "../../../components/Form";
import { Select, TextInput } from "../../../components/Inputs";
import { useTranslations } from "../../../providers/useTranslations";
const CITY_NAME = "city";
export const CityField = ({ fieldName: getFieldName, isCityLimitationEnabled, deliveryLimitCitiesDropdownList, orderDeliveryLimits, }) => {
    const { __ } = useTranslations();
    const { control } = useFormContext();
    const fieldName = getFieldName(CITY_NAME);
    const validateCity = (city) => {
        if (!isCityLimitationEnabled) {
            return true;
        }
        const isValid = orderDeliveryLimits?.limits.some(({ name }) => name === city);
        return isValid || __("address_fields.city.error.delivery_limit");
    };
    return (_jsx(Controller, { name: fieldName, control: control, rules: { required: __("form_validation.field_required"), validate: { validateCity } }, render: ({ field, fieldState: { error } }) => {
            const commonSettings = {
                dataTestId: "city",
                name: fieldName,
                "aria-label": "city",
                isError: !!error,
                isHelperTextVisible: !!error,
                helperText: error?.message,
                showRequiredAsterisk: true,
                label: __(`address_fields.city`),
                placeholder: __("address_fields.city_placeholder"),
            };
            return isCityLimitationEnabled ? (_jsx(Select, { ...field, options: deliveryLimitCitiesDropdownList, onChange: (selectedOption) => field.onChange(selectedOption?.value), value: field.value ? { label: field.value, value: field.value } : null, ...commonSettings })) : (_jsx(TextInput, { ...field, ...commonSettings }));
        } }));
};
//# sourceMappingURL=CityField.js.map